<template>
	<div class="control-group" :class="{filled: date, active: focused, error: errors && errors.length > 0, disabled: disabled}">
		<div class="control-holder">
			<label v-if="label" :class="{'has-prepend': prependIcon}">{{ label }}<span v-if="required">*</span></label>
			<div class="input" :class="{'has-append': appendIcon, 'has-prepend': prependIcon}">
				<span v-if="prependIcon" @click.prevent="$emit('click:prepend')" class="prepend-icon">
					<icon :icon="prependIcon"></icon>
				</span>
				<div class="input-holder">
			        <input 
			        	v-if="width < 980"
				        :type="nativeType" 
				        :disabled="disabled" 
				        :readonly="readonly"
				        v-model="date" 
				        :autocomplete="(autocomplete)?autocomplete:false" 
				        @click="$emit('focus')"
				        @focus="focused = true; $emit('focus')" 
				        @blur="focused = false; $emit('blur')" 
				        @change="$emit('change', $event)"
				        @keyup="$emit('keyup', $event)"
			        />
			        <vuejs-datepicker 
			        	format="MM/dd/yyyy"
			        	v-model="date" 
			        	:disabled="disabled"
			        	:required="required"
			        	v-if="width >= 980"
			        	:clear-button="false"
			        ></vuejs-datepicker>
			    </div>
		    	<span v-if="appendIcon" @click.prevent="date = null" class="append-icon">
		    		<icon :icon="appendIcon"></icon>
		    	</span>
		    </div>
		</div>
        <transition name="slide-down">
            <div class="error-text" v-if="errors && errors.length > 0">
                <div v-for="error in errors">{{ error }}</div>
            </div>
        </transition>
    </div>
</template>

<script>
	export default {
		props: ['value', 'label', 'errors', 'required', 'disabled', 'autocomplete', 'readonly', 'includeTime'],
		data() {
			return {
				prependIcon: 'office/calendar/calendar-date',
				appendIcon: (this.value)?'essentials/basics/close-circle':null,
				date: this.value,
				focused: false
			}
		},
		computed: {
			width() {
				return this.$store.state.screenWidth;
			},
			nativeType() {
				if(this.date || this.focused) {
					return (this.includeTime)?'datetime-local':'date';
				}
				return 'text';
			}
		},
		watch: {
			date() {
				if(this.date) {
					this.appendIcon = 'essentials/basics/close-circle';
				} else {
					this.appendIcon = null;
				}
				this.$emit('input', this.date);
			},
			value() {
				this.date = this.value;
			}
		}
	}
</script>